export interface Scenario {
  id: string;
  icon: string;
  title: string;
  description: string;
  image: string;
}

export const scenarios: Scenario[] = [
  {
    id: 'scenario-1',
    icon: 'ri-building-2-line',
    title: '企业数字化转型',
    description: 'mrds 帮助企业打破数据孤岛，实现业务流程的全面数字化和智能化，从传统运营模式迈向数据驱动的新型企业。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20with%20digital%20displays%20showing%20data%20analytics%2C%20professional%20team%2C%20clean%20minimalist%20design%2C%20warm%20lighting%2C%20technology%20driven%20workplace&width=600&height=400&seq=scenario-enterprise&orientation=landscape',
  },
  {
    id: 'scenario-2',
    icon: 'ri-store-2-line',
    title: '电商运营优化',
    description: 'mrds 为电商企业提供全链路数据分析与自动化运营能力，从流量分析到订单管理，全面提升电商运营效率和转化率。',
    image: 'https://readdy.ai/api/search-image?query=Ecommerce%20analytics%20dashboard%20on%20large%20screen%2C%20modern%20office%20setting%2C%20product%20images%20and%20data%20charts%2C%20warm%20atmosphere%2C%20professional%20workspace&width=600&height=400&seq=scenario-ecommerce&orientation=landscape',
  },
  {
    id: 'scenario-3',
    icon: 'ri-hospital-line',
    title: '医疗健康管理',
    description: 'mrds 在医疗健康领域提供安全合规的数据管理与分析服务，助力医疗机构提升诊疗效率和服务质量。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20healthcare%20technology%20concept%2C%20clean%20medical%20environment%20with%20digital%20displays%2C%20data%20analytics%20in%20healthcare%2C%20bright%20professional%20setting%2C%20warm%20organic%20elements&width=600&height=400&seq=scenario-healthcare&orientation=landscape',
  },
  {
    id: 'scenario-4',
    icon: 'ri-bank-line',
    title: '金融服务创新',
    description: 'mrds 助力金融机构实现风险管控、客户分析和合规管理的智能化，以数据驱动金融服务创新与转型升级。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20technology%20office%2C%20digital%20displays%20with%20financial%20charts%2C%20professional%20environment%2C%20clean%20minimalist%20design%2C%20warm%20golden%20accent%20lighting&width=600&height=400&seq=scenario-finance&orientation=landscape',
  },
];